import "./page_linked_path.scss"

